import React, {useContext, useEffect, useReducer} from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import {Dropdown} from 'semantic-ui-react';

import {customerActions, ticketActions} from 'actions';
import {getContactName, formValidation} from 'helpers';

import {DictionaryContext} from 'Common/DictionaryContext';

const EmailSelect = props => {
  const dictionary = useContext(DictionaryContext);
  const [state, setState] = useReducer(
    (state, newState) => ({...state, ...newState}),
    {
      customerEmailList: [],
      loadingEmailList: false,
    },
  );

  useEffect(() => {
    if (!props.skipLoad) {
      loadEmailList();
    }
  }, []);

  const loadEmailList = async () => {
    setState({
      loadingEmailList: true,
      sendReceipt: true,
    });

    const data = props.ticketId
      ? await props.loadTicketEmailList(props.ticketId)
      : await props.loadCustomerEmailList(props.customerId);

    if (data.length > 0) {
      if (!props.receiptEmails || props.value.length === 0) {
        props.update([data.find(x => x.isDefault).email]);
      } else {
        props.update(props.receiptEmails);
      }
    }

    const addedEmails = props.receiptEmails
      ? props.receiptEmails
          .filter(e => !data.map(em => em.EmailAddress).includes(e))
          .map(e => ({DisplayName: e, EmailAddress: e}))
      : [];

    setState({
      customerEmailList: [
        ...data.map(e => ({
          DisplayName: `${getContactName(
            e,
            dictionary.CustomerContact.value,
          )} (${e.type})`,
          EmailAddress: e.email,
        })),
        ...addedEmails,
      ],
      loadingEmailList: false,
    });
  };

  const handleReceiptEmailAddition = (e, {value}) =>
    formValidation.isEmail(value)
      ? setState({
          customerEmailList: [
            ...state.customerEmailList,
            {
              EmailAddress: value,
              DisplayName: value,
            },
          ],
        })
      : null;

  return (
    <Dropdown
      allowAdditions
      fluid
      loading={state.loadingEmailList}
      multiple
      noResultsMessage="No Email Addresses to display."
      onAddItem={handleReceiptEmailAddition}
      onChange={(e, {value}) => props.update(value)}
      options={state.customerEmailList.map((e, key) => ({
        key,
        text: `${e.DisplayName} (${e.EmailAddress})`,
        value: e.EmailAddress,
      }))}
      placeholder="Email Addresses"
      search
      selection
      style={{minWidth: 300}}
      value={props.value}
    />
  );
};

EmailSelect.defaultProps = {
  receiptEmails: [],
  skipLoad: false,
  ticketId: null,
  value: [],
};

EmailSelect.propTypes = {
  customerId: PropTypes.number.isRequired,
  receiptEmails: PropTypes.array,
  skipLoad: PropTypes.bool,
  ticketId: PropTypes.number,
  value: PropTypes.array,

  // functions
  loadCustomerEmailList: PropTypes.func.isRequired,
  loadTicketEmailList: PropTypes.func.isRequired,
  update: PropTypes.func.isRequired,
};

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      loadCustomerEmailList: customerActions.getCustomerEmailList,
      loadTicketEmailList: ticketActions.getTicketEmailList,
    },
    dispatch,
  );

export default connect(
  null,
  mapDispatchToProps,
)(EmailSelect);



// WEBPACK FOOTER //
// ./src/components/Common/Form/EmailSelect.js